<template>
  <v-message-page
    :msg="this.msg"
    msg-type="success"
    icon="check"
    :buttons="noButtons ? [] : [next]"
  />
</template>

<script>
import MessagePage from '@/common/components/MessagePage.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Success',
  data() {
    return {
      msg: 'sentence.generic_success',
      noButtons: false,
    };
  },
  computed: {
    ...mapGetters(['org']),
    dashboard() {
      return this.org ? 'organisation' : 'dashboard';
    },
  },
  components: {
    'v-message-page': MessagePage,
  },
  created() {
    this.next = this.$route.query.next || this.dashboard;
    if (this.$route.query.msg) {
      this.msg = this.$route.query.msg;
    }
    if (this.$route.query.nb) {
      this.noButtons = true;
    }
  },
};
</script>
